/**
 * generates old screens array used to do streaming ("watch" and "switch" Janus commands with streaming plugin),
 * based on the new data received from the backend in the following APIs:
 * 1. GET /lw/:lid that returns meeting object that has the new `screens` array.
 * 2. `joining-janus` SSE Event that is sent to current user that after a join API call.
 * @param {{screenId: string, osSlug: string}[]} newScreens data from `meeting.screens`
 * @param {{[screenId]: number}} screenStreamIds data from `janusConfigs.screenStreamIds`
 */
export default function getOldScreensArray(newScreens, screenStreamIds) {
  return [
    {
      id: -1,
      stream_id: Math.max(...Object.values(screenStreamIds)) + 1, // e.g. 103 for LW1, 204 for LW2, ...
      mini_track_name: "v105-mini",
      name: "base",
      res: [200, 150, 42, 32],
    },
    ...newScreens.map(({ screenId, osSlug, sendServerName }, i) => {
      const screenNum = i + 1;
      const stream_id = screenStreamIds[screenId];
      return {
        id: stream_id,
        stream_id,
        screen_id: screenId,
        main_track_name: "v101",
        mini_track_name: `v${100 + screenNum + 1}-mini`, // e.g. v102-mini, v103-mini, ...
        os: osSlug === "win10" ? "Windows 10" : "Ubuntu",
        os_icon_file_name: osSlug === "win10" ? "windows" : "ubuntu",
        name: `screen_${stream_id}`,
        res: [200, 150, 102, 76],
        io_m_res: [1920, 1200],
        io_ws_path_template: `wss://${sendServerName}.lab.sgigs.com/lws-TYPE-${screenId}`, // TODO: remove this after refactoring FE & BE
      };
    }),
  ];
}
